
<div class="row">
  <div class="col-12 text-center" style="width:100%">
    <div class="card" style="height:200px">
        <div class="card-header" style="background-color: #dbd3be; font-family: open-sans;">
            <h2 style="font-size:25px ; font-family: open-sans"  strong>Otp Confirmation</h2>  
          </div>
            <div class="row">
              <div class="col-12">
                <label style="color:#9b7544">Enter Otp Here</label>
              </div>
              <div class="col-12">
                  <input type= "password" [(ngModel)]="otpdata">
                </div>
            </div>
            
    </div>
    <div class="card-footer" style="margin-top:50px">
        <div class="row">
          <div class="col-6">
              <button class="btn btn-success btn-block" *ngIf="otpdata" (click)="verifyUser()">Confirm</button> 
          </div>
          <div class="col-6">
             <button class="btn btn-success3 btn-block" (click)="closeDialog(0)">Cancel</button> 
          </div>
        </div>
      </div>
  </div>
</div>

